module.exports = __webpack_public_path__ + "static/media/isdoctorplan-bariatric3@3x.9895cebe.png";